export default {
  name: "Gardening Van Check",
  description: "Checklist for vans used by gardening teams — includes equipment safety.",
  required: ["Name", "LicensePlate", "Mileage"],
  fields: [
    { key: "Name", label: "Name", type: "text", required: true },
    { key: "Date", label: "Date", type: "date" },
    { key: "Department", label: "Department", type: "text" },
    { key: "LicensePlate", label: "Vehicle Number Plate", type: "text", required: true },
    { key: "Mileage", label: "Mileage", type: "number", required: true },
    { key: "Equipment", label: "Check Tools and Equipment", type: "text" },
    { key: "FuelLevel", label: "Fuel Level", type: "text" },
    { key: "Cleanliness", label: "Cleanliness of Vehicle", type: "text" },
    { key: "Damage", label: "Any Visible Damage", type: "text" },
    { key: "Safety", label: "Safety Gear Present (PPE, cones, etc.)", type: "text" },
    { key: "Notes", label: "Additional Notes", type: "textarea" }
  ],
  photos: true
};
